/* src/app/private/components/contact-group/create-contact-group/create-contact-group.component.scss */
label {
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 12px;
}
.errors {
  font-size: 12px;
  color: red;
}
/*# sourceMappingURL=create-contact-group.component.css.map */
